import {
    SALES_INTREST_CALCULATION_REPORT_REQUEST,
    SALES_INTREST_CALCULATION_REPORT_SUCCESS,
    SALES_INTREST_CALCULATION_REPORT_FAILURE
} from '../types/sales-intrest-calculation-report-types';

const initialState = {
    salesInterestCalculation: {},
    loading: false,
    data: null,
    error: null
};

const salesInterestCalculationReducer = (state = initialState, action) => {
    switch (action.type) {
        case SALES_INTREST_CALCULATION_REPORT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case SALES_INTREST_CALCULATION_REPORT_SUCCESS:
            console.log('Reducer received data:', action.payload);
            return {
                ...state,
                salesInterestCalculation: {...(action.payload || {})},
                loading: false,
                data: action.payload,
                error: null
            };
        case SALES_INTREST_CALCULATION_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            };
        default:
            return state;
    }
};

export default salesInterestCalculationReducer;
